<template>
  <div class="ds-info-box relationship-refusal-banner" :class="`ds-info-box--${tone}`" role="alert">
    <v-icon class="ds-info-box__icon" :color="tone">{{ copy.icon || 'mdi-alert-circle-outline' }}</v-icon>
    <div class="relationship-refusal-banner__content">
      <strong>{{ copy.title }}</strong>
      <div v-if="copy.text">{{ copy.text }}</div>
      <div v-if="copy.action" class="relationship-refusal-banner__next">
        <b>What you can do:</b> {{ copy.action }}
      </div>
      <relationship-code-detail class="relationship-refusal-banner__code" :code="copy.code" />
    </div>
    <div v-if="$slots.default" class="relationship-refusal-banner__actions">
      <slot />
    </div>
  </div>
</template>

<script>
import RelationshipCodeDetail from './RelationshipCodeDetail.vue';

// Title, one-line reason, next step and a small copyable code for a whole-run refusal
// (config/relationshipRefusalCopy.js problemCopy). The default slot holds the recovery button.
export default {
  name: 'RelationshipRefusalBanner',
  components: { RelationshipCodeDetail },
  props: {
    copy: { type: Object, required: true },
  },
  computed: {
    tone() { return this.copy.tone === 'error' ? 'error' : 'warning'; },
  },
};
</script>

<style lang="scss" scoped>
.relationship-refusal-banner { align-items: flex-start; }
.relationship-refusal-banner__content {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  font-size: var(--ds-font-body-sm);
  line-height: 1.5;
}
.relationship-refusal-banner__content strong { font-weight: 600; }
.relationship-refusal-banner__next { margin-top: 2px; }
.relationship-refusal-banner__next b { font-weight: 600; }
.relationship-refusal-banner__code { margin-top: 2px; }
.relationship-refusal-banner__actions { display: flex; flex: 0 0 auto; align-items: center; gap: var(--ds-space-xs); }

@media (max-width: 720px) {
  .relationship-refusal-banner { flex-wrap: wrap; }
  .relationship-refusal-banner__actions { width: 100%; justify-content: flex-end; }
}
</style>
